/* eslint no-undef: 'off' */
/* eslint no-console: 'off' */
import $ from 'jquery';

const el = {
    target_content  : ".kb-Overview .kb-OverviewPanel",
    navButton  : ".js-overview-nav-btn"
}

const handler_overview = () => {
    $(document).on('click', el.navButton, function (e){
        e.preventDefault();
        const date = $(this).data('full_date');
        const ajax      = themeObj.ajaxOverviewBooking;

        const data = {
            action: ajax.action,
            nonce: ajax.nonce,
            date: date,
        }

        $.ajax({
            url: themeObj.ajaxUrl,
            type: "POST",
            data: data,
        })
        .done((response) => {
            const target_content = $(el.target_content);
              target_content.fadeOut(300, function() {
                target_content.html(response.html);
                target_content.fadeIn(300);
            });

            $(el.navButton).removeClass('Active');
            $(this).addClass('Active');
        })
    });
}

const init = () => {
    handler_overview();
}

try {
    init();
} catch (error) {
    console.error(error);
}